import { render, staticRenderFns } from "./kpsrRiskRegister.vue?vue&type=template&id=0483d180"
import script from "./kpsrRiskRegister.vue?vue&type=script&lang=js"
export * from "./kpsrRiskRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0483d180')) {
      api.createRecord('0483d180', component.options)
    } else {
      api.reload('0483d180', component.options)
    }
    module.hot.accept("./kpsrRiskRegister.vue?vue&type=template&id=0483d180", function () {
      api.rerender('0483d180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/risk/kpsrRiskRegister.vue"
export default component.exports